module.exports = __webpack_public_path__ + "static/img/22.ba4eb6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/22.jpg
// module id = 1qw7
// module chunks = 0